<template>
    <div>
        <button v-if="row.isEdit === false" class="btn_modify" @click="onClickEditButton"/>
    </div>
</template>
<script>
export default {
    name:'PGE_AIM_00001_C02',
    components:{},
    props:{
        row:{type:Object, default: () => {},},
        value:{type:String, default:'',}
    },
    data(){
        return {
        }
    },
    created(){},
    mounted(){},
    computed:{
    },
    methods:{
        onClickEditButton(){
           this.row.isEdit = true;
        },
    }
}
</script>
<style lang="scss" scoped>
    .btn_modify {
        width:16px;
        height:16px;
        background:url('../../../../../assets/images/aicc/ic_modify.png');
    }
</style>